// src/pages/Orders/storage/orderingDraft.ts

import { OrderPostCompanyViewModel } from '../ViewModels/OrderPostViewModels';

export type DraftLine = {
  productId: string;
  orderedQuantity: number;
  unitPrice: number;
  vendorProductUrl?: string; // hvis URL ble endret i UI
};

export type DraftUnitPriceByUrl = Record<string, number>; // urlKey -> unitPrice

export type OrderingDraft = {
  lines: Record<string, DraftLine>; // productId -> DraftLine
  unitPriceByUrl: DraftUnitPriceByUrl; // felles kostpris per url
  selectedProductIds: Record<string, true>;
  selectedVendor: OrderPostCompanyViewModel | null;
  freightCost: number;
  vendorOrderNumber?: string;
  version: 2;
};

const DRAFT_KEY = 'orderposts:ordering-draft:v2';

export function loadDraft(): OrderingDraft | null {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as OrderingDraft;
    if (parsed?.version !== 2) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveDraft(d: OrderingDraft) {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify(d));
    console.log('Draft lagret', d);
  } catch {
    // ignore
  }
}

export function clearDraft() {
  try {
    localStorage.removeItem(DRAFT_KEY);
  } catch {
    // ignore
  }
}

// Hjelper for å hente en gyldig draft alltid
export function getOrCreateDraft(): OrderingDraft {
  return (
    loadDraft() ?? {
      version: 2,
      lines: {},
      unitPriceByUrl: {},
      selectedProductIds: {},
      selectedVendor: null,
      freightCost: 0,
      vendorOrderNumber: '',
    }
  );
}
